/** @format */

import * as actions from '../actions/multicastGroupDevices';

const defaultState = {
  filter: {},
  sort: {},
  isLoading: false,
  error: false,
};

export const multicastGroupDevices = (state = defaultState, action) => {
  switch (action.type) {
    case actions.FETCH_MULTICAST_GROUP_DEVICES_REQUEST:
      return {
        isLoading: true,
        error: false,
      };
    case actions.FETCH_MULTICAST_GROUP_DEVICES_SUCCESS:
      return {
        ...action.payload,
        isLoading: false,
        error: false,
      };
    case actions.FETCH_MULTICAST_GROUP_DEVICES_FAILURE:
      return {
        ...action.payload,
        isLoading: false,
        error: true,
      };

    case actions.POST_MULTICAST_GROUP_DEVICES_REQUEST:
      return {
        isLoading: true,
        error: false,
      };
    case actions.POST_MULTICAST_GROUP_DEVICES_SUCCESS:
      return {
        ...action.payload,
        isLoading: false,
        error: false,
      };
    case actions.POST_MULTICAST_GROUP_DEVICES_FAILURE:
      return {
        ...action.payload,
        isLoading: false,
        error: true,
      };

    case actions.DELETE_MULTICAST_GROUP_DEVICES_REQUEST:
      return {
        isLoading: true,
        error: false,
      };
    case actions.DELETE_MULTICAST_GROUP_DEVICES_SUCCESS:
      return {
        ...action.payload,
        isLoading: false,
        error: false,
      };
    case actions.DELETE_MULTICAST_GROUP_DEVICES_FAILURE:
      return {
        ...action.payload,
        isLoading: false,
        error: true,
      };

    case actions.DESTROY_MULTICAST_GROUP_DEVICES_SUCCESS:
      return {
        isLoading: false,
        error: false,
      };

    default:
      return state;
  }
};

export const multicastGroupDevicesMap = (state = defaultState, action) => {
  switch (action.type) {
    case actions.FETCH_MULTICAST_GROUP_DEVICES_MAP_REQUEST:
      return {
        isLoading: true,
        error: false,
      };
    case actions.FETCH_MULTICAST_GROUP_DEVICES_MAP_SUCCESS:
      return {
        ...action.payload,
        isLoading: false,
        error: false,
      };
    case actions.FETCH_MULTICAST_GROUP_DEVICES_MAP_FAILURE:
      return {
        ...action.payload,
        isLoading: false,
        error: true,
      };

    case actions.DESTROY_MULTICAST_GROUP_DEVICES_MAP_SUCCESS:
      return {
        isLoading: false,
        error: false,
      };

    default:
      return state;
  }
};
